import { DatePicker } from "@mui/x-date-pickers-pro";
import { GridFilterInputValueProps } from "@mui/x-data-grid-pro";

export const GridFilterDateInput = (props: GridFilterInputValueProps) => {
  const { item, applyValue, headerFilterMenu, clearButton, slotProps } = props;

  const handleFilterChange = (newValue: Date | null) => {
    if (newValue !== null && Number.isNaN(newValue.getTime())) return;
    applyValue({ ...item, value: newValue });
  };

  return (
    <>
      <DatePicker
        value={item.value ? new Date(item.value) : null}
        slotProps={{ textField: { ...slotProps?.root } }}
        onChange={handleFilterChange}
      />
      {headerFilterMenu}
      {clearButton}
    </>
  );
};
